import React from 'react';
import T from 'prop-types';

export const Title = ({ text, className }) => {
    return <div className={className}>{text}</div>;
};

Title.T = {
    text: T.string,
    className: T.string,
};

Title.defaultProps = {
    className: 'titleDefaultCls',
};
